'use strict';

var _ = require('lodash');
var config = require('./config/config');
var MapConfig = require('./config/MapConfig');

function MapConfigProvider () {

  _.extend(this, config);

  this.$get = function () {
    return new MapConfig(this);
  }.bind(this);
}

module.exports = MapConfigProvider;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/MapConfigProvider.js